<script>
  import { createEventDispatcher } from 'svelte';
  import { sumBy, map, orderBy, forEach } from 'lodash-es';

  const dispatch = createEventDispatcher();

  import Page from './Page.svelte';
  import Words from './Words.svelte';

  export let name = '';
  export let date = '';
  export let pages = [];
  export let words = [];
  export let showSpace = false;

  let hoveredWord = undefined;
  let hoveredPage = undefined;
  let pagesWithGaps = [];

  $: dimmedPages = map(pages, d => {
    let isDimmed = false;
    if (hoveredWord !== undefined) {
      isDimmed = d.words[hoveredWord] === undefined;
    }
    return {
      ...d,
      isDimmed,
    };
  });

  $: {
    if (showSpace) {
      let lastIssue = '';
      const output = [];
      forEach(dimmedPages, d => {
        if (lastIssue !== d.issue) {
          output.push({
            issue: d.issue,
            type: 'space',
            page: 'space',
            text: d.issue[5] + d.issue[6],
          });
          lastIssue = d.issue;
        }
        output.push({ ...d, type: 'page' });
      });
      pagesWithGaps = output;
    } else {
      pagesWithGaps = map(dimmedPages, d => ({ ...d, type: 'page' }));
    }
  }

  $: highlightedWords = map(words, d => ({
    ...d,
    value:
      hoveredPage !== undefined && hoveredPage.words[d.word]
        ? hoveredPage.words[d.word]
        : d.value,
    isHighlighted: hoveredPage !== undefined && hoveredPage.words[d.word],
  }));

  $: numInfectedPage = sumBy(pages, 'infected');
</script>

<style type="text/scss">
  @import './styles/theme.scss';
  .department {
    @include fluid-space(margin-bottom, $sp-medium);
  }
  .department__header {
    @include fluid-space(padding-top padding-bottom, $sp-xxsmall);
    color: #333;
    font-family: $ff-serif;
    font-weight: $fw-bold;
    @include fluid-font-size($fs-semi-medium);
  }
  .department__header-date {
    @include fluid-font-size($fs-base);
    font-weight: normal;
    font-family: $ff-sans;
    color: $c-gray-2;
  }
  .department__pages {
    @include fluid-space(margin-top, $sp-xxsmall);
    display: flex;
    flex-wrap: wrap;
  }

  .department__page {
    transition: all 0.5s;
  }
  .department__space {
    @include fluid-font-size($fs-small);
    color: $c-gray-2;
    display: flex;
    align-items: center;
    width: 36px;
    justify-content: center;
  }
  .department__page.is-dimed {
    opacity: 0.2;
    pointer-events: none;
  }
</style>

<div class="department">
  <div class="department__header">
    {name}
    {#if date !== ''}
      <span class="department__header-date">(Angesteckt seit {date})</span>
    {/if}
  </div>

  <div class="department__words">
    <Words
      items={highlightedWords}
      on:mouseover={d => (hoveredWord = d.detail.id)}
      on:mouseout={d => (hoveredWord = undefined)} />
  </div>

  <div class="department__pages">
    {#each pagesWithGaps as page (`${page.issue}-${page.page}`)}
      {#if page.type === 'page'}
        <div class="department__page" class:is-dimed={page.isDimmed}>
          <Page
            items={page.items}
            isInfected={page.infected > 0}
            on:mouseover={() => {
              hoveredPage = page;
              dispatch('mouseover', { issue: page.issue, page: page.page });
            }}
            on:mouseout={() => {
              hoveredPage = undefined;
              dispatch('mouseout');
            }} />
        </div>
      {:else}
        <div class="department__space">
          <span>{page.text}</span>
        </div>
      {/if}
    {/each}
  </div>

</div>
